import { render, staticRenderFns } from "./PlusIngredientCombo.vue?vue&type=template&id=6465fd21&scoped=true"
import script from "./PlusIngredientCombo.vue?vue&type=script&lang=ts"
export * from "./PlusIngredientCombo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6465fd21",
  null
  
)

export default component.exports